module.exports = __webpack_public_path__ + "img/logo-list-5.f9eeb5ba.png";